var Styles = {"tw-react--region-selector--modal":"RegionSelector-module_tw-react--region-selector--modal__QFs48","tw-react--region-selector--modal--region--country--selected":"RegionSelector-module_tw-react--region-selector--modal--region--country--selected__CRJme"};

export { Styles as default };
